import styled from 'styled-components';
import { Table, Form, Button } from 'react-bootstrap';
import { ToReadableDate } from '../../../utils';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClaimItemsGetService, ClaimDocumentsGetService } from '../../../domain';
import { PaginationComponent } from '../claim-review';

const SubDescription = styled.div`
    font-size: 15px;
    font-weight: 300;
    padding: 5px 0px;
`;

const StyledSubmitButton1 = styled(Button)`
    max-width: fit-content;
    padding: 5px 40px;
    border-radius: 25px;
    font-family: 'Montserrat';
    font-weight: 400;
    font-size: 12px;
    color: white;
    text-align: left;

    &:disabled {
        background-color: #808080;
        border-color: #808080;
    }
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;

    @media (min-width: 300px) and (max-width: 500px) {
        justify-content: center;
    }
`;

const TableContainer = styled.div`
    overflow-x: auto;
    white-space: nowrap;
    padding: 0;
    margin: 0;
    width: 100%;
`;

export default function ShowClaimsView({
    formData,
    setFormData,
    setLoading,
    claimTypes,
    claimsData,
    docPerClaimTypes,
    updateClaimsData,
    handleFormSubmit,
    bindAvailableClaims
}) {
    const claimsCheckboxesRef = useRef({});
    const [hasSelectedClaim, setHasSelectedClaim] = useState(false);
    const navigate = useNavigate();

    const _ClaimItemsGetService = new ClaimItemsGetService();
    const _ClaimDocumentsGetService = new ClaimDocumentsGetService();

    const processRef = (element, id) => {
        if (element) {
            claimsCheckboxesRef.current[id] = element;
            if (formData.selectedClaim === id) {
                claimsCheckboxesRef.current[id].checked = true;
            }
        }
    };

    const showClaimType = (id) => {
        const claimType = claimTypes.find((item) => item.id === id);
        // console.log(claimType);

        return claimType;
    };

    const bindAvailableClaimDocuments = async (id) => {
        const documents = await _ClaimDocumentsGetService.execute({ id: id });
        return documents;
    };

    const bindClaimItems = async (id) => {
        const claimItems = await _ClaimItemsGetService.execute({ id });
        return claimItems;
    };

    const handleClaimsSelection = async (event = null) => {
        console.log('event: ', event);

        if (!event) {
            const { customerDetails, ...policyCustomerDetails } = formData.availablePolicy.find(
                (item) => item.id === formData.selectedPolicy
            );

            const setPayload = {
                ...formData,
                createNewClaim: true,
                selectedClaim: 'create new claim',
                claimsPayload: {
                    refId: formData.claimsPayload.refId,
                    refTable: formData.claimsPayload.refTable,
                    status: 'Pending',
                    customerDetails: {
                        ...customerDetails,
                        ...policyCustomerDetails
                    }
                }
            };
            setFormData(setPayload);

            Object.keys(claimsCheckboxesRef.current).forEach((key) => {
                claimsCheckboxesRef.current[key].checked = false;
            });

            updateClaimsData({ ...setPayload, createNewClaim: true });
            navigate('/selection');

            return;
        }

        setLoading(true);
        const claimItems = await bindClaimItems(event.id);
        const documents = await bindAvailableClaimDocuments(event.id);
        setLoading(false);

        // map the document details to the pulled document if theres any.
        const docPerClaimTypesFiltered = docPerClaimTypes.filter(
            (item) => item.mtnClaimTypeId === event.mtnClaimTypeId
        );
        // console.log('docPerClaimTypes": ', docPerClaimTypes);

        const mappedDocuments = docPerClaimTypesFiltered.map((item) => ({
            ...item,
            attachedDocuments: documents.claimDocuments.filter(
                (docItem) => docItem.mtnDocumentTypeId === item.mtnDocumentTypeId
            )
        }));
        // console.log('mappedDocuments', mappedDocuments);
        // console.log('documents', documents);

        setFormData({
            ...formData,
            selectedClaim: event.id,
            createNewClaim: false,
            claimsPayload: {
                ...formData.claimsPayload,
                ...event,
                ...claimItems,
                claimDocuments: mappedDocuments
            }
        });

        // check | uncheck the selected checkbox
        if (formData?.selectedClaim !== event.id) {
            Object.keys(claimsCheckboxesRef.current).forEach((key) => {
                if (key !== event.id.toString()) {
                    claimsCheckboxesRef.current[key].checked = false;
                } else {
                    claimsCheckboxesRef.current[key].checked = true;
                    setHasSelectedClaim(true);
                }
            });
        } else {
            setFormData({
                ...formData,
                selectedClaim: null,
                createNewClaim: false
                // claimsPayload: {}
            });
            setHasSelectedClaim(false);

            Object.keys(claimsCheckboxesRef.current).forEach((key) => {
                if (key === event.id.toString()) {
                    claimsCheckboxesRef.current[key].checked = false;
                }
            });

            // if (formData?.createNewClaim || typeof formData?.selectedClaim === 'string') {
            //     updateClaimsData(formData);
            //     navigate('/selection');
            //     return;
            // }
        }
    };

    const pageChange = async (page) => {
        setLoading(true);
        const claims = await bindAvailableClaims(formData.selectedPolicy, page);

        Object.keys(claimsCheckboxesRef.current).forEach((key) => {
            claimsCheckboxesRef.current[key].checked = false;
        });
        setHasSelectedClaim(false);

        const setPayload = {
            ...formData,
            selectedClaim: undefined,
            availableClaims: claims.claims,
            availableClaimsPagination: {
                totalData: claims.totalData,
                totalPage: claims.totalPage,
                currentPage: claims.currentPage
            },
            claimsPayload: {
                refId: formData.claimsPayload.refId,
                refTable: 'txn_uploaded_policy',
                status: 'Pending',
                customerDetails: {
                    ...formData.claimsPayload.customerDetails
                }
            }
        };
        setFormData(setPayload);
        console.log('new claims data on page change: ', setPayload);
        setLoading(false);
    };

    return (
        <div>
            <SubDescription>
                {/* <i className="bi bi-info-circle" style={{ padding: '2px', fontSize: '14px' }}></i> */}
                You can select your existing claims to proceed or you can file a new one.
            </SubDescription>
            <TableContainer>
                <Table striped bordered hover>
                    <thead className="text-center">
                        <tr>
                            <th width="2%"></th>
                            <th>Acknowledgement Reference No.</th>
                            <th>Nature of Loss</th>
                            <th>Incident Date</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        {formData?.availableClaims &&
                            claimTypes &&
                            formData.availableClaims.map((item, index) => {
                                return (
                                    <tr key={'policyItem_' + index}>
                                        <td className="text-center">
                                            <Form.Check
                                                className="checkbox"
                                                style={{ margin: '3px 5px 0px 7px' }}
                                                type="checkbox"
                                                name="agreed"
                                                // ref={(el) => (claimsCheckboxesRef.current[item.id] = el)}
                                                ref={(el) => processRef(el, item.id)}
                                                onClick={() => handleClaimsSelection(item)}
                                            ></Form.Check>
                                        </td>
                                        <td>{item.refNo}</td>
                                        <td>{showClaimType(item.mtnClaimTypeId)?.claimTypeDesc}</td>
                                        <td>{ToReadableDate(item.incidentDate)}</td>
                                    </tr>
                                );
                            })}
                        {!formData?.availableClaims.length && (
                            <tr className="text-center">
                                <td colSpan="7">No claims available.</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </TableContainer>

            {formData?.availableClaimsPagination?.totalData > 5 && (
                <ButtonContainer>
                    <PaginationComponent
                        totalPage={formData?.availableClaimsPagination?.totalPage}
                        currentPage={formData?.availableClaimsPagination?.currentPage}
                        onPageChange={pageChange}
                    />
                </ButtonContainer>
            )}

            {!!formData?.availableClaims?.length && (
                <ButtonContainer>
                    <StyledSubmitButton1
                        className="btn-submit"
                        variant={formData.createNewClaim ? 'secondary' : 'primary'}
                        type="button"
                        disabled={hasSelectedClaim || typeof formData?.selectedClaim === 'number'}
                        onClick={() => handleClaimsSelection(null)}
                    >
                        I want to file a new Claim
                    </StyledSubmitButton1>
                </ButtonContainer>
            )}
        </div>
    );
}
